import { TBColumn } from "../../../../interfaces/TableBits.interfaces";
const columns: TBColumn[] = [
  {
    id: "bussinesName",
    label: "Nombre",
    align: "left",
  },
  {
    id: "nameEnterprise",
    label: "Empresa",
    align: "left",
  },
  {
    id: "campus",
    label: "Sede",
    align: "left",
  },
  {
    id: "project",
    label: "Proyecto/Área",
    align: "left",
  },
  {
    id: "status",
    label: "Estatus",
    align: "left",
  },
  {
    id: "calificationUser",
    label: "Calificación obtenida",
    align: "left",
  },
  {
    id: "dateAdd",
    label: "Fecha",
    align: "left",
  },
];

export default columns;
